import GovGrButton from "../GovGrButton";

const VIEW_LABEL_DEFAULT_VALUE = "Προβολή";

const ViewButton = ({
  disabled,
  handleViewFile,
  viewLabel = VIEW_LABEL_DEFAULT_VALUE,
}) => {
  if (disabled) {
    return null;
  }

  return (
    <GovGrButton
      style={{ marginLeft: "5px" }}
      buttonText={viewLabel}
      variant="link"
      onClick={handleViewFile}
    />
  );
};

export default ViewButton;
